import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild, ViewEncapsulation } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzPaginationI18nInterface } from "ng-zorro-antd/i18n";
import { NzPaginationSimpleComponent } from "ng-zorro-antd/pagination";
import { PaginationItemRenderContext } from "../../pagination.models";

@Component({
  selector: "ui-pagination-simple",
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "pagination-simple.component.html",
})
export class UiPaginationSimpleComponent extends NzPaginationSimpleComponent {
  @ViewChild("containerTemplate", { static: true }) public template!: TemplateRef<NzSafeAny>;
  @Input("itemRender") public itemRender: TemplateRef<PaginationItemRenderContext> | null = null;
  @Input("disabled") public disabled = false;
  @Input("locale") public locale!: NzPaginationI18nInterface;
  @Input("total") public total = 0;
  @Input("pageIndex") public pageIndex = 1;
  @Input("pageSize") public pageSize = 10;
  @Output("pageIndexChange") public readonly pageIndexChange = new EventEmitter<number>();
}
